import React, { Component } from "react";
import {
  Button,
  TextField,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  MenuItem,
  FormControl,
  InputLabel,
  Select,
  Box,
  List,
  ListItem,
  ListItemText,
  ListItemButton,
  Divider,
  CircularProgress,
  Typography,
} from "@mui/material";
import { apiUrl } from "../apiUrl";
import { ArrowBack } from "@mui/icons-material";

class SelecionarCliente extends Component {
  constructor(props) {
    super(props);
    this.state = {
      tipoFiltro: "2",
      valorBusca: "",
      loading: false,
      clientes: [], // Lista que vem do fetch
      exibirLista: false, // Controla se mostra o form ou os resultados
    };
  }

  handleChange = (e) => {
    this.setState({ [e.target.name]: e.target.value });
  };

  handleBuscar = async (event) => {
    event.preventDefault();
    this.setState({ loading: true });

    try {
      const response = await fetch(`${apiUrl}/buscar-cliente`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          authorization: localStorage.getItem("token"),
        },
        body: JSON.stringify({
          filter: this.state.tipoFiltro,
          search: this.state.valorBusca,
        }),
      });

      const data = await response.json();
      this.setState({ clientes: data.items || [], exibirLista: true });
    } catch (error) {
      console.error("Erro ao buscar clientes:", error);
      alert("Erro na busca");
    } finally {
      this.setState({ loading: false });
    }
  };

  handleSelecionar = (cliente) => {
    if (this.props.onSelect) {
      this.props.onSelect(cliente);
    }
    this.fecharELimpar();
  };

  fecharELimpar = () => {
    this.setState({
      tipoFiltro: "2",
      valorBusca: "",
      clientes: [],
      exibirLista: false,
    });
    this.props.onClose();
  };

  render() {
    const { open } = this.props;
    const { loading, exibirLista, clientes } = this.state;

    return (
      <Dialog open={open} onClose={this.fecharELimpar} fullWidth maxWidth="sm">
        <DialogTitle>
          {exibirLista ? "Selecione o Cliente" : "Buscar Cliente"}
        </DialogTitle>

        <DialogContent dividers>
          {!exibirLista ? (
            /* FORMULÁRIO DE BUSCA */
            <Box
              component="form"
              onSubmit={this.handleBuscar}
              sx={{ display: "flex", flexDirection: "column", gap: 2, mt: 1 }}
            >
              <FormControl fullWidth variant="standard">
                <InputLabel>Critério</InputLabel>
                <Select
                  name="tipoFiltro"
                  value={this.state.tipoFiltro}
                  onChange={this.handleChange}
                  required
                >
                  <MenuItem value="1">Cod. cliente</MenuItem>
                  <MenuItem value="2">Nome do Cliente</MenuItem>
                  <MenuItem value="4">CNPJ</MenuItem>
                  <MenuItem value="5">CPF</MenuItem>
                </Select>
              </FormControl>
              <TextField
                name="valorBusca"
                label="Digite sua busca"
                fullWidth
                variant="standard"
                required
                value={this.state.valorBusca}
                onChange={this.handleChange}
              />
              <Button
                type="submit"
                variant="contained"
                disabled={loading}
                sx={{ mt: 2 }}
              >
                {loading ? <CircularProgress size={24} /> : "Pesquisar"}
              </Button>
            </Box>
          ) : (
            /* LISTA DE RESULTADOS */
            <List>
              {clientes.length > 0 ? (
                clientes.map((cliente) => {
                  // Validação rigorosa dos dados de endereço
                  const temEnderecoInvalido =
                    !cliente.endereco?.toString().trim() ||
                    !cliente.numero?.toString().trim() ||
                    !cliente.bairro?.toString().trim() ||
                    !cliente.cidade?.toString().trim() ||
                    !cliente.estado?.toString().trim() ||
                    !cliente.cep?.toString().trim();

                  // Desabilita por status ou por falta de dados fiscais/endereço
                  const isDisabled =
                    cliente.status === 1 ||
                    cliente.status === 3 ||
                    temEnderecoInvalido && this.props.operation == "venda";

                  return (
                    <React.Fragment key={cliente.id}>
                      <ListItem disablePadding>
                        <ListItemButton
                          disabled={isDisabled}
                          onClick={() => this.handleSelecionar(cliente)}
                        >
                          <ListItemText
                            primary={cliente.nome}
                            secondary={
                              temEnderecoInvalido && this.props.operation == "venda" ? (
                                <Typography
                                  component="span"
                                  variant="caption"
                                  color="error"
                                  sx={{
                                    display: "block",
                                    fontWeight: "bold",
                                    mt: 0.5,
                                  }}
                                >
                                  Endereço incompleto. Favor atualizar o
                                  cadastro do cliente antes de prosseguir.
                                </Typography>
                              ) : (
                                `CPF/CNPJ: ${cliente.cnpj_cpf || "---"} | ${cliente.cidade} - ${cliente.estado}`
                              )
                            }
                          />
                        </ListItemButton>
                      </ListItem>
                      <Divider />
                    </React.Fragment>
                  );
                })
              ) : (
                <Typography
                  variant="body2"
                  color="textSecondary"
                  align="center"
                >
                  Nenhum cliente encontrado.
                </Typography>
              )}
            </List>
          )}
        </DialogContent>

        <DialogActions>
          {exibirLista && (
            <Button
              onClick={() => this.setState({ exibirLista: false })}
              color="primary"
              startIcon={<ArrowBack />}
            >
              Voltar para busca
            </Button>
          )}
          <Button onClick={this.fecharELimpar} color="inherit">
            Cancelar
          </Button>
        </DialogActions>
      </Dialog>
    );
  }
}

export default SelecionarCliente;